import { useQueryClient } from "@tanstack/react-query";
import { ordersQueryKeyFactory } from "hooks/api/orders/useOrders";

const useRefetchOrders = () => {
  const queryClient = useQueryClient();
  return (contractNumber?: number) =>
    queryClient.refetchQueries({
      queryKey: ordersQueryKeyFactory(contractNumber),
    });
};

export default useRefetchOrders;
